import { render } from "./ProductMultiSelectQuickSearch.vue?vue&type=template&id=5640636f&scoped=true"
import script from "./ProductMultiSelectQuickSearch.vue?vue&type=script&lang=js"
export * from "./ProductMultiSelectQuickSearch.vue?vue&type=script&lang=js"

import "./ProductMultiSelectQuickSearch.vue?vue&type=style&index=0&id=5640636f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5640636f"],['__file',"src/components/ProductMultiSelectQuickSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5640636f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5640636f', __exports__)) {
    api.reload('5640636f', __exports__)
  }
  
  module.hot.accept("./ProductMultiSelectQuickSearch.vue?vue&type=template&id=5640636f&scoped=true", () => {
    api.rerender('5640636f', render)
  })

}


export default __exports__